import React, { useEffect } from "react";
import { motion } from "framer-motion";

const ThankYou=()=>{

    useEffect(() => {
        document.title =
        "Thank You | Dr. Jigar Gor Ayurvedic Clinic";
                
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
        metaDesc.setAttribute(
        "content",
        "Thank you for connecting with us. Your submission has been received successfully, and we look forward to assisting you."
        );
    }
                
        const canonical = document.querySelector("link[rel='canonical']");
        if (canonical) {
        canonical.setAttribute("href", "https://msayurved.com/thank-you");
        }
                
        const ogTitle = document.querySelector("meta[property='og:title']");
        if (ogTitle) {
        ogTitle.setAttribute(
        "content",
        "Thank You | Dr. Jigar Gor Ayurvedic Clinic"
        );
    }
                
        const ogDesc = document.querySelector("meta[property='og:description']");
        if (ogDesc) {
        ogDesc.setAttribute(
        "content",
        "Thank you for connecting with us. Your submission has been received successfully, and we look forward to assisting you."
        );
    }
                
        const ogUrl = document.querySelector("meta[property='og:url']");
        if (ogUrl) {
        ogUrl.setAttribute("content", "https://msayurved.com/thank-you");
        }
                
        const ogImage = document.querySelector("meta[property='og:image']");
        if (ogImage) {
        ogImage.setAttribute(
        "content",
        "https://msayurved.com/Images/home.webp"
        );
    }
                
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
        if (twitterTitle) {
        twitterTitle.setAttribute(
        "content",
        "Thank You | Dr. Jigar Gor Ayurvedic Clinic"
        );
    }
                
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
    );
        if (twitterDesc) {
        twitterDesc.setAttribute(
        "content",
        "Thank you for connecting with us. Your submission has been received successfully, and we look forward to assisting you."
        );
    }
                
        const twitterImage = document.querySelector("meta[name='twitter:image']");
        if (twitterImage) {
        twitterImage.setAttribute(
        "content",
        "https://msayurved.com/Images/home.webp"
        );
    }
}, []);

  useEffect(() => {
    const shouldTrack = sessionStorage.getItem(
      "trackThankYouLead"
    );

    if (shouldTrack === "true") {
      sessionStorage.removeItem("trackThankYouLead");

      if (typeof window.fbq === "function") {
        window.fbq(
          "trackCustom",
          "ThankYouPage"
        );
      }
    }
  }, []);

    return(
        <>
        <motion.section
          className="error-page container"
          initial={{
            opacity: 0,
            y: 40,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
            amount: 0.2,
          }}
          transition={{
            duration: 1.2,
            ease: "easeOut",
          }}
        >
        
          <motion.h1
            className="hero-heading"
            initial={{
              opacity: 0,
              y: 30,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 1,
              delay: 0.2,
              ease: "easeOut",
            }}
          >
           Thank You for<br /> Reaching Out!
          </motion.h1>
        
          <motion.p
            className="section-text"
            initial={{
              opacity: 0,
              y: 20,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 1,
              delay: 0.45,
              ease: "easeOut",
            }}
          >
           Thank you for taking the time to connect with us. We have received your information successfully and appreciate your trust in us.<br /> Our team will review your submission and get in touch with you.
          </motion.p>
        
          <motion.a
            className="primary-btn"
            href="/"
            initial={{
              opacity: 0,
              y: 20,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 0.9,
              delay: 0.7,
              ease: "easeOut",
            }}
            whileHover={{
              y: -3,
              scale: 1.02,
            }}
            whileTap={{
              scale: 0.97,
            }}
          >
            Back to Homepage
          </motion.a>
        
        </motion.section>
        </>
    )
}
export default ThankYou;